import { Card } from 'antd';
import styled from 'styled-components';

export const StyledPatientsCard = styled(Card)`
  border-radius: 0;
  background-color: #ffffff;
  border: 1px solid #f4f4f4;
  box-shadow: #f5f5f5 2px 0px 12px;
  height: calc(100vh - 118px);
  overflow-y: auto;
  &&& {
    .ant-list-header {
      border: none;
      padding: 32px 24px 16px;
    }
    .patients-header {
      h5 {
        font-size: 16px;
        color: #0b1a30;
        margin-bottom: 24px;
      }
      p {
        font-size: 14px;
        color: #6b7083;
        line-height: 1.5;
      }
      input {
        background-color: #fbfbfb;
        border: 1px solid #f4f4f4;
      }
    }
    .ant-card-body {
      padding: 0;
    }
    .ant-list-item {
      padding: 16px 24px;
      border-block-end: 1px solid #f4f4f4;
      transition: background-color 0.2s;
      &:hover,
      &.active-list-item {
        background-color: #fbfbfb;
      }
    }
    .list-item-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #2552f3;
      display: flex;
      align-items: center;
      justify-content: center;
      object-fit: cover;
    }
    .list-item-text {
      margin: 0;
    }
  }
`;
